// round to 2 decimal places
export function Round2(number) {
    return Math.round(number * 100) / 100;
}